<template lang="pug">
.container
  ul.tab.tab-block(v-if="filterByFileFormat && availableFileFormats.length")
    li.tab-item(v-for="fileFormat in availableFileFormats")
      a.c-hand(@click="currentFileFormat = fileFormat" :class="{ active: currentFileFormat === fileFormat }") {{ fileFormat | uppercase }}
  .columns
    .column.col-4.col-lg-6.col-sm-12.mb-2.pb-2
      .empty
        .empty-icon
          i.fas.fa-newspaper.fa-4x
        p.empty-title.h5 Adicionar item
        p.empty-subtitle Clique para escolher o arquivo
        .empty-action
          input.form-input(type="file" @change="onSelect" ref="fileRef")
    .column.col-4.col-lg-6.col-sm-12.mb-2.pb-2(v-for="productItem in list")
      row(:disabled="disabled" :productItem="productItem" @remove="emitRemoveItem" @update="openProductItemForm(productItem)")
  product-item-form(v-if="showProductItemForm" :file="file" :item="productItemToEdit" @submit-form="submitProductItemForm"
                    :productType="productType" @close-modal="closeProductItemForm")
</template>

<script>
import ProductItemModel from '@/lib/products/ProductItemModel'
import ProductItemForm from './ProductItemForm'
import Row from './Row'

export default {
  props: {
    productItems: { type: Array, required: true },
    productType: { type: String, required: true },
    disabled: { type: Boolean, required: true },
  },

  data() {
    return {
      currentFileFormat: null,
      showProductItemForm: false,
      productItemToEdit: null,
      productItemFormSubmitFunction: null,
      file: null,
    }
  },

  components: { Row, ProductItemForm },

  computed: {
    filterByFileFormat() {
      const productTypesToFilter = ['magazine', 'book']

      return productTypesToFilter.includes(this.productType)
    },

    availableFileFormats() {
      const { productItems } = this
      if (!productItems.length) return []

      const fileFormats = productItems.map(item => item.fileFormat)
      return [...new Set(fileFormats)]
    },

    list() {
      if (this.filterByFileFormat) {
        return this.productItems.filter(
          item => item.fileFormat === this.currentFileFormat,
        )
      }

      return this.productItems
    },

    newItem() {
      const map = {
        book: 'Novo capítulo',
        magazine: 'Novo artigo',
        video: 'Novo vídeo',
        course: 'Novo item',
      }

      return map[this.productType]
    },
  },

  created() {
    this.setCurrentFormat()
  },

  methods: {
    onSelect(e) {
      const file = e.target.files[0]
      this.file = file
      this.openProductItemForm()
    },
    openProductItemForm(productItem = null) {
      this.productItemToEdit = ProductItemModel()
      this.productItemFormSubmitFunction = this.emitAddItem

      if (productItem) {
        this.productItemToEdit = productItem
        this.productItemFormSubmitFunction = this.emitUpdateItem
      }

      this.showProductItemForm = true
    },

    closeProductItemForm() {
      this.showProductItemForm = false
      this.setCurrentFormat()
      this.productItemFormSubmitFunction = null
      this.$refs.fileRef.value = ''
    },

    setCurrentFormat() {
      if (this.filterByFileFormat) {
        this.currentFileFormat = this.availableFileFormats[0] || null
      }
    },

    submitProductItemForm(productItem) {
      this.productItemFormSubmitFunction(productItem)
      this.closeProductItemForm()
    },

    emitAddItem(productItem) {
      this.$emit('add-item', productItem)
    },

    emitUpdateItem(productItem) {
      this.$emit('edit-item', productItem)
    },

    emitRemoveItem(productItem) {
      this.$emit('remove-item', productItem)
      this.setCurrentFormat()
    },
  },
}
</script>

<style lang="stylus" scoped>
.text-right
  padding-bottom 10px
</style>
